/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getClientSubscription = /* GraphQL */ `
  query GetClientSubscription($id: ID!) {
    getClientSubscription(id: $id) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listClientSubscriptions = /* GraphQL */ `
  query ListClientSubscriptions(
    $filter: ModelClientSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientSubscriptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getPlatformSubscription = /* GraphQL */ `
  query GetPlatformSubscription($id: ID!) {
    getPlatformSubscription(id: $id) {
      id
      name
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listPlatformSubscriptions = /* GraphQL */ `
  query ListPlatformSubscriptions(
    $filter: ModelPlatformSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlatformSubscriptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getPlatform = /* GraphQL */ `
  query GetPlatform($id: ID!) {
    getPlatform(id: $id) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      owner
      clients {
        items {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        platformId
        email
        createdOn
        updatedOn
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
      }
      users {
        items {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const listPlatforms = /* GraphQL */ `
  query ListPlatforms(
    $filter: ModelPlatformFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlatforms(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getClient = /* GraphQL */ `
  query GetClient($id: ID!) {
    getClient(id: $id) {
      id
      subscriptionId
      adminId
      createdOn
      updatedOn
      subscription {
        id
        name
        createdAt
        updatedAt
        owner
      }
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
      notifications {
        items {
          id
          clientId
          title
          message
          link
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      admin {
        id
        clientId
        identityId
        email
        webPushAlias
        webPushDescription
        webPushSubLink
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        webPushSubscribers {
          nextToken
        }
        webPushes {
          nextToken
        }
      }
      users {
        items {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushSubscribers {
        items {
          id
          clientId
          token
          type
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      pluginPushes {
        items {
          id
          clientId
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      integrations {
        items {
          id
          integrationId
          clientId
          accessToken
          refreshToken
          dataKey
          insightJobPending
          allScopes
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const listClients = /* GraphQL */ `
  query ListClients(
    $filter: ModelClientFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getNotification = /* GraphQL */ `
  query GetNotification($id: ID!) {
    getNotification(id: $id) {
      id
      clientId
      title
      message
      link
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
    }
  }
`;
export const listNotifications = /* GraphQL */ `
  query ListNotifications(
    $filter: ModelNotificationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        title
        message
        link
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
      }
      nextToken
    }
  }
`;
export const getClientUser = /* GraphQL */ `
  query GetClientUser($id: ID!) {
    getClientUser(id: $id) {
      id
      clientId
      identityId
      email
      webPushAlias
      webPushDescription
      webPushSubLink
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      owner
      webPushSubscribers {
        items {
          id
          clientUserId
          token
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
      webPushes {
        items {
          id
          clientUserId
          sentTo
          title
          content
          alias
          opens
          dismissals
          successfulPush
          successfulDelivery
          createdOn
          updatedOn
          owner
        }
        nextToken
      }
    }
  }
`;
export const listClientUsers = /* GraphQL */ `
  query ListClientUsers(
    $filter: ModelClientUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listClientUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        identityId
        email
        webPushAlias
        webPushDescription
        webPushSubLink
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        webPushSubscribers {
          nextToken
        }
        webPushes {
          nextToken
        }
      }
      nextToken
    }
  }
`;
export const getWebPushSubscriber = /* GraphQL */ `
  query GetWebPushSubscriber($id: ID!) {
    getWebPushSubscriber(id: $id) {
      id
      clientUserId
      token
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listWebPushSubscribers = /* GraphQL */ `
  query ListWebPushSubscribers(
    $filter: ModelWebPushSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebPushSubscribers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientUserId
        token
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getWebPush = /* GraphQL */ `
  query GetWebPush($id: ID!) {
    getWebPush(id: $id) {
      id
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listWebPushs = /* GraphQL */ `
  query ListWebPushs(
    $filter: ModelWebPushFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebPushs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientUserId
        sentTo
        title
        content
        alias
        opens
        dismissals
        successfulPush
        successfulDelivery
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getPluginPushSubscriber = /* GraphQL */ `
  query GetPluginPushSubscriber($id: ID!) {
    getPluginPushSubscriber(id: $id) {
      id
      clientId
      token
      type
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listPluginPushSubscribers = /* GraphQL */ `
  query ListPluginPushSubscribers(
    $filter: ModelPluginPushSubscriberFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPluginPushSubscribers(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        clientId
        token
        type
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getPluginPush = /* GraphQL */ `
  query GetPluginPush($id: ID!) {
    getPluginPush(id: $id) {
      id
      clientId
      clientUserId
      sentTo
      title
      content
      alias
      opens
      dismissals
      successfulPush
      successfulDelivery
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listPluginPushs = /* GraphQL */ `
  query ListPluginPushs(
    $filter: ModelPluginPushFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPluginPushs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        clientId
        clientUserId
        sentTo
        title
        content
        alias
        opens
        dismissals
        successfulPush
        successfulDelivery
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getPlatformUser = /* GraphQL */ `
  query GetPlatformUser($id: ID!) {
    getPlatformUser(id: $id) {
      id
      platformId
      email
      createdOn
      updatedOn
      platform {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        owner
        clients {
          nextToken
        }
        admin {
          id
          platformId
          email
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
      }
      owner
    }
  }
`;
export const listPlatformUsers = /* GraphQL */ `
  query ListPlatformUsers(
    $filter: ModelPlatformUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPlatformUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        platformId
        email
        createdOn
        updatedOn
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
      }
      nextToken
    }
  }
`;
export const getEmPushyIntegration = /* GraphQL */ `
  query GetEmPushyIntegration($id: ID!) {
    getEmPushyIntegration(id: $id) {
      id
      name
      logo
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listEmPushyIntegrations = /* GraphQL */ `
  query ListEmPushyIntegrations(
    $filter: ModelEmPushyIntegrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listEmPushyIntegrations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        name
        logo
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getActiveIntegration = /* GraphQL */ `
  query GetActiveIntegration($id: ID!) {
    getActiveIntegration(id: $id) {
      id
      integrationId
      clientId
      accessToken
      refreshToken
      dataKey
      insightJobPending
      allScopes
      createdOn
      updatedOn
      client {
        id
        subscriptionId
        adminId
        createdOn
        updatedOn
        subscription {
          id
          name
          createdAt
          updatedAt
          owner
        }
        platform {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        owner
        notifications {
          nextToken
        }
        admin {
          id
          clientId
          identityId
          email
          webPushAlias
          webPushDescription
          webPushSubLink
          createdOn
          updatedOn
          owner
        }
        users {
          nextToken
        }
        pluginPushSubscribers {
          nextToken
        }
        pluginPushes {
          nextToken
        }
        integrations {
          nextToken
        }
      }
      integration {
        id
        name
        logo
        createdAt
        updatedAt
        owner
      }
      owner
    }
  }
`;
export const listActiveIntegrations = /* GraphQL */ `
  query ListActiveIntegrations(
    $filter: ModelActiveIntegrationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listActiveIntegrations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      nextToken
    }
  }
`;
export const getIntegrationOverview = /* GraphQL */ `
  query GetIntegrationOverview($id: ID!) {
    getIntegrationOverview(id: $id) {
      id
      numCampaigns
      numSent
      avgSent
      avgDelivered
      avgBounce
      avgClick
      avgOpen
      wordFrequency
      prevOpened
      prevDelivered
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const listIntegrationOverviews = /* GraphQL */ `
  query ListIntegrationOverviews(
    $filter: ModelIntegrationOverviewFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationOverviews(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        numCampaigns
        numSent
        avgSent
        avgDelivered
        avgBounce
        avgClick
        avgOpen
        wordFrequency
        prevOpened
        prevDelivered
        createdOn
        updatedOn
        activeIntegration {
          id
          integrationId
          clientId
          accessToken
          refreshToken
          dataKey
          insightJobPending
          allScopes
          createdOn
          updatedOn
          owner
        }
        owner
      }
      nextToken
    }
  }
`;
export const getIntegrationABDelivery = /* GraphQL */ `
  query GetIntegrationABDelivery($id: ID!) {
    getIntegrationABDelivery(id: $id) {
      id
      activeIntegrationId
      idVariantA
      idVariantB
      createdOn
      updatedOn
      activeIntegration {
        id
        integrationId
        clientId
        accessToken
        refreshToken
        dataKey
        insightJobPending
        allScopes
        createdOn
        updatedOn
        client {
          id
          subscriptionId
          adminId
          createdOn
          updatedOn
          owner
        }
        integration {
          id
          name
          logo
          createdAt
          updatedAt
          owner
        }
        owner
      }
      owner
    }
  }
`;
export const listIntegrationABDeliverys = /* GraphQL */ `
  query ListIntegrationABDeliverys(
    $filter: ModelIntegrationABDeliveryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listIntegrationABDeliverys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        activeIntegrationId
        idVariantA
        idVariantB
        createdOn
        updatedOn
        activeIntegration {
          id
          integrationId
          clientId
          accessToken
          refreshToken
          dataKey
          insightJobPending
          allScopes
          createdOn
          updatedOn
          owner
        }
        owner
      }
      nextToken
    }
  }
`;
export const getFeedback = /* GraphQL */ `
  query GetFeedback($id: ID!) {
    getFeedback(id: $id) {
      id
      message
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listFeedbacks = /* GraphQL */ `
  query ListFeedbacks(
    $filter: ModelFeedbackFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFeedbacks(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        message
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getDashboardCard = /* GraphQL */ `
  query GetDashboardCard($id: ID!) {
    getDashboardCard(id: $id) {
      id
      title
      textContent
      likes
      state
      videoContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listDashboardCards = /* GraphQL */ `
  query ListDashboardCards(
    $filter: ModelDashboardCardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDashboardCards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        textContent
        likes
        state
        videoContent
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getCallToActionCard = /* GraphQL */ `
  query GetCallToActionCard($id: ID!) {
    getCallToActionCard(id: $id) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listCallToActionCards = /* GraphQL */ `
  query ListCallToActionCards(
    $filter: ModelCallToActionCardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCallToActionCards(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        title
        textContent
        likes
        state
        videoContent
        imageContent
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
export const getUrgencyCard = /* GraphQL */ `
  query GetUrgencyCard($id: ID!) {
    getUrgencyCard(id: $id) {
      id
      title
      textContent
      likes
      state
      videoContent
      imageContent
      createdOn
      updatedOn
      owner
    }
  }
`;
export const listUrgencyCards = /* GraphQL */ `
  query ListUrgencyCards(
    $filter: ModelUrgencyCardFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUrgencyCards(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        textContent
        likes
        state
        videoContent
        imageContent
        createdOn
        updatedOn
        owner
      }
      nextToken
    }
  }
`;
